let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("gXJ2i")).then(() => parcelRequire('asNEt'));